(() => {
  if (window.__NWSB_GALLERY_MONTHLY_WEBP_V29__) return;
  window.__NWSB_GALLERY_MONTHLY_WEBP_V29__ = true;

  const assetOrigin =
    window.NWSB_GALLERY_ASSET_ORIGIN ||
    "https://newwave-gallery-assets.newaveswim.com";
  const release = "monthly-webp-v29";
  const months = ["2017-05","2017-06","2017-07","2017-08","2017-09","2017-10","2017-11","2017-12","2018-01","2018-02","2018-03","2018-04","2018-05","2018-06","2018-07","2018-08","2018-09","2018-10","2018-11","2018-12","2019-01","2019-02","2019-03","2019-04","2019-05","2019-06","2019-07","2019-08","2019-09","2019-10","2019-11","2019-12","2020-01","2020-02","2020-03","2020-04","2020-05","2020-06","2020-07","2020-08","2020-09","2020-10","2020-11","2020-12","2021-01","2021-02","2021-03","2021-04","2021-05","2021-06","2021-07","2021-08","2021-09","2021-10","2021-11","2021-12","2022-01","2022-02","2022-03","2022-04","2022-05","2022-06","2022-07","2022-08","2022-09","2022-10","2022-11","2022-12","2023-01","2023-02","2023-03","2023-04","2023-05","2023-06","2023-07","2023-08","2023-09","2023-10","2023-11","2023-12","2024-01","2024-02","2024-03","2024-04","2024-05","2024-06","2024-07","2024-08","2024-09","2024-10","2024-11","2024-12","2025-01","2025-02","2025-03","2025-04","2025-05","2025-06","2025-07","2025-08","2025-09","2025-10","2025-11","2025-12","2026-01","2026-02","2026-03","2026-04","2026-05","2026-06","2026-07","2026-08"];
  if (!months.length) return;

  if (!document.querySelector('link[href*="native-instagram-gallery-linked.css"]')) {
    const stylesheet = document.createElement("link");
    stylesheet.rel = "stylesheet";
    stylesheet.href = `${assetOrigin}/releases/native-instagram-gallery-20260904-monthly-webp-v28.css?v=${release}`;
    document.head.appendChild(stylesheet);
  }

  const withVersion = (path) => {
    if (!path) return "";
    const url = /^https?:\/\//i.test(path) ? new URL(path) : new URL(path, assetOrigin);
    url.searchParams.set("v", release);
    return url.href;
  };
  const manifestUrl = (key) =>
    `${assetOrigin}/releases/manifests/v28/${key}.json?v=${release}`;
  const monthLabel = (key) =>
    new Intl.DateTimeFormat("en-US", {
      month: "long",
      year: "numeric",
      timeZone: "UTC",
    }).format(new Date(`${key}-01T00:00:00Z`));
  const navArrow = (direction) =>
    `<svg class="nwsb-native-gallery__nav-icon" viewBox="0 0 48 48" aria-hidden="true" focusable="false"><circle class="nwsb-native-gallery__nav-disc" cx="24" cy="24" r="22.5"/><path class="nwsb-native-gallery__nav-chevron" d="${direction === "prev" ? "M28 15 19 24 28 33" : "M20 15 29 24 20 33"}"/></svg>`;
  const monthToolbar = (placement) =>
    `<nav class="nwsb-native-gallery__toolbar nwsb-native-gallery__toolbar--${placement}" aria-label="${placement === "top" ? "Gallery month navigation" : "Gallery month navigation after album"}"><button class="nwsb-native-gallery__month-button" data-month-step="-1" type="button" aria-label="Previous month">${navArrow("prev")}</button><label class="nwsb-native-gallery__picker"><select data-month-select aria-label="${placement === "top" ? "Choose gallery month" : "Choose gallery month after album"}"></select></label><button class="nwsb-native-gallery__month-button" data-month-step="1" type="button" aria-label="Next month">${navArrow("next")}</button></nav>`;

  const pathMatch = location.pathname.match(/\/(20\d{2}-\d{2})-/);
  const requestedMonth = new URLSearchParams(location.search).get("gallery-month");
  let currentMonth = months.includes(requestedMonth)
    ? requestedMonth
    : pathMatch && months.includes(pathMatch[1])
      ? pathMatch[1]
      : months[months.length - 1];

  const placeholders = [
    ...document.querySelectorAll('[class*="sapp-"], [class*="elfsight-app-"]'),
  ];
  const placeholder = placeholders[0];
  const content = document.querySelector(".rte, .page-content, main");
  const mount = placeholder || content;
  if (!mount) return;
  placeholders.forEach((element) => {
    element.hidden = true;
    element.setAttribute("aria-hidden", "true");
  });
  document
    .querySelectorAll('script[src*="elfsight.com"],script[src*="instashow"]')
    .forEach((element) => element.remove());

  const gallery = document.createElement("section");
  gallery.className = "nwsb-native-gallery";
  gallery.innerHTML = `${monthToolbar("top")}<h2 class="nwsb-native-gallery__title">Best Swim Buoy Instagram Highlights — ${monthLabel(currentMonth)}</h2><div class="nwsb-native-gallery__grid" aria-live="polite"></div>${monthToolbar("bottom")}`;

  const modal = document.createElement("div");
  modal.className = "nwsb-native-gallery__modal";
  modal.hidden = true;
  modal.setAttribute("role", "dialog");
  modal.setAttribute("aria-modal", "true");
  modal.setAttribute("aria-label", "Instagram gallery viewer");
  modal.innerHTML = `<div class="nwsb-native-gallery__backdrop" data-close></div><div class="nwsb-native-gallery__dialog"><button class="nwsb-native-gallery__close" type="button" data-close aria-label="Close viewer">&times;</button><button class="nwsb-native-gallery__post-nav nwsb-native-gallery__post-nav--prev" type="button" data-post-step="-1" aria-label="Previous post">${navArrow("prev")}</button><article class="nwsb-native-gallery__post"><header><span class="nwsb-native-gallery__avatar">NW</span><a class="nwsb-native-gallery__author" href="" target="_blank" rel="noopener noreferrer"></a><span class="nwsb-native-gallery__verified" aria-label="Verified">&#10003;</span></header><div class="nwsb-native-gallery__stage"><button class="nwsb-native-gallery__media-nav nwsb-native-gallery__media-nav--prev" type="button" data-media-step="-1" aria-label="Previous media item in this post">${navArrow("prev")}</button><img alt=""><video controls playsinline muted preload="metadata" hidden></video><button class="nwsb-native-gallery__media-nav nwsb-native-gallery__media-nav--next" type="button" data-media-step="1" aria-label="Next media item in this post">${navArrow("next")}</button><span class="nwsb-native-gallery__media-counter" aria-live="polite"></span></div><footer><span class="nwsb-native-gallery__icons" aria-hidden="true">♡ &nbsp; ◯ &nbsp; ◇</span><p class="nwsb-native-gallery__social-proof" hidden></p><p class="nwsb-native-gallery__caption"><a class="nwsb-native-gallery__caption-author" href="" target="_blank" rel="noopener noreferrer"></a> <span class="nwsb-native-gallery__caption-text"></span></p><span class="nwsb-native-gallery__counter"></span></footer></article><button class="nwsb-native-gallery__post-nav nwsb-native-gallery__post-nav--next" type="button" data-post-step="1" aria-label="Next post">${navArrow("next")}</button></div>`;

  if (placeholder) placeholder.insertAdjacentElement("afterend", gallery);
  else content.prepend(gallery);
  document.body.appendChild(modal);

  const grid = gallery.querySelector(".nwsb-native-gallery__grid");
  const selects = [...gallery.querySelectorAll("[data-month-select]")];
  [...months].reverse().forEach((key) => {
    selects.forEach((select) => {
      const option = document.createElement("option");
      option.value = key;
      option.textContent = monthLabel(key);
      select.appendChild(option);
    });
  });

  const cache = new Map();
  const inflight = new Map();
  let currentRecord = null;
  let activeIndex = 0;
  let activeSlide = 0;
  let returnFocus = null;
  let renderSequence = 0;

  const setQueryMonth = (key) => {
    const url = new URL(location.href);
    url.searchParams.set("gallery-month", key);
    history.replaceState({}, "", url);
  };
  const keepOnlyAdjacent = (key) => {
    const index = months.indexOf(key);
    const allowed = new Set([months[index - 1], key, months[index + 1]].filter(Boolean));
    [...cache.keys()].forEach((cachedKey) => {
      if (!allowed.has(cachedKey)) cache.delete(cachedKey);
    });
  };
  const loadMonth = (key, priority = "auto") => {
    if (cache.has(key)) return Promise.resolve(cache.get(key));
    if (inflight.has(key)) return inflight.get(key);
    const promise = fetch(manifestUrl(key), {
      cache: "force-cache",
      credentials: "omit",
      priority,
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Gallery month ${key} returned ${response.status}`);
        return response.json();
      })
      .then((record) => {
        if (!Array.isArray(record.posts) || !record.posts.length) {
          throw new Error(`Gallery month ${key} has no posts`);
        }
        cache.set(key, record);
        return record;
      })
      .finally(() => inflight.delete(key));
    inflight.set(key, promise);
    return promise;
  };
  const prefetchAdjacent = (key) => {
    const run = () => {
      const index = months.indexOf(key);
      [months[index - 1], months[index + 1]].filter(Boolean).forEach((neighbor) => {
        loadMonth(neighbor, "low").catch(() => {});
      });
      keepOnlyAdjacent(key);
    };
    if ("requestIdleCallback" in window) requestIdleCallback(run, { timeout: 2500 });
    else setTimeout(run, 800);
  };
  const updateMonthButtons = (key, busy = false) => {
    const index = months.indexOf(key);
    gallery.querySelectorAll('[data-month-step="-1"]').forEach((button) => {
      button.disabled = busy || index === 0;
    });
    gallery.querySelectorAll('[data-month-step="1"]').forEach((button) => {
      button.disabled = busy || index === months.length - 1;
    });
  };
  const showSkeleton = () => {
    const count = 12;
    grid.replaceChildren();
    for (let index = 0; index < count; index += 1) {
      const item = document.createElement("span");
      item.className = "nwsb-native-gallery__item nwsb-native-gallery__item--loading";
      item.setAttribute("aria-hidden", "true");
      grid.appendChild(item);
    }
  };
  const renderPosts = (key, record) => {
    grid.replaceChildren();
    record.posts.forEach((post, index) => {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "nwsb-native-gallery__item";
      button.setAttribute(
        "aria-label",
        `View post ${index + 1} of ${record.posts.length} without leaving this site`,
      );
      const image = document.createElement("img");
      const firstMedia = post.media?.[0];
      const thumb = post.thumb || {};
      image.src = withVersion(
        thumb.src || firstMedia?.poster || firstMedia?.src || post.images?.[0] || post.image,
      );
      image.alt = `New Wave Swim Buoy Instagram highlight ${index + 1} for ${monthLabel(key)}`;
      image.loading = index < 4 ? "eager" : "lazy";
      image.decoding = "async";
      image.fetchPriority = index === 0 ? "high" : "auto";
      if (thumb.width) image.width = thumb.width;
      if (thumb.height) image.height = thumb.height;
      button.appendChild(image);
      button.addEventListener("click", () => openModal(index));
      grid.appendChild(button);
    });
  };
  async function renderMonth(key, updateUrl = true) {
    if (!months.includes(key)) return;
    const sequence = ++renderSequence;
    currentMonth = key;
    currentRecord = null;
    selects.forEach((select) => {
      select.value = key;
      select.disabled = true;
    });
    gallery.querySelector(".nwsb-native-gallery__title").textContent =
      `Best Swim Buoy Instagram Highlights — ${monthLabel(key)}`;
    gallery.setAttribute("aria-busy", "true");
    updateMonthButtons(key, true);
    showSkeleton();
    try {
      const record = await loadMonth(key, "high");
      if (sequence !== renderSequence) return;
      currentRecord = record;
      gallery.setAttribute("aria-label", record.name || monthLabel(key));
      renderPosts(key, record);
      if (updateUrl) setQueryMonth(key);
      prefetchAdjacent(key);
    } catch (error) {
      if (sequence !== renderSequence) return;
      grid.replaceChildren();
      const message = document.createElement("p");
      message.className = "nwsb-native-gallery__error";
      message.textContent = "This gallery month could not be loaded. Please try another month.";
      grid.appendChild(message);
      console.error(error);
    } finally {
      if (sequence === renderSequence) {
        gallery.removeAttribute("aria-busy");
        selects.forEach((select) => {
          select.disabled = false;
        });
        updateMonthButtons(key, false);
      }
    }
  }

  const postMedia = (post) =>
    post.media?.length
      ? post.media
      : (post.images?.length ? post.images : [post.image]).map((src) => ({
          type: "image",
          src,
        }));
  function sizeModalForItem(item) {
    const dialog = modal.querySelector(".nwsb-native-gallery__dialog");
    const post = modal.querySelector(".nwsb-native-gallery__post");
    const header = post.querySelector("header");
    const footer = post.querySelector("footer");
    const viewportWidth = Math.floor(window.visualViewport?.width || window.innerWidth);
    const viewportHeight = Math.floor(window.visualViewport?.height || window.innerHeight);
    const mobile = viewportWidth <= 600;
    const outerVerticalSpace = mobile ? 62 : 96;
    const headerHeight = Math.ceil(header.getBoundingClientRect().height || 58);
    const footerLimit = mobile ? Math.floor(viewportHeight * 0.3) : 190;
    const footerHeight = Math.min(Math.max(footer.scrollHeight || 96, 72), footerLimit);
    const availableStageHeight = Math.max(
      220,
      viewportHeight - outerVerticalSpace - headerHeight - footerHeight,
    );
    const mediaWidth = Number(item?.width) || 1;
    const mediaHeight = Number(item?.height) || 1;
    const mediaAspect = Math.min(4, Math.max(0.25, mediaWidth / mediaHeight));
    const horizontalSpace = mobile ? 20 : 160;
    const availablePostWidth = Math.max(240, viewportWidth - horizontalSpace);
    const minimumPostWidth = Math.min(availablePostWidth, mobile ? 280 : 360);
    const postWidth = Math.min(
      availablePostWidth,
      Math.max(minimumPostWidth, Math.round(availableStageHeight * mediaAspect)),
    );
    const stageHeight = Math.min(
      availableStageHeight,
      Math.round(postWidth / mediaAspect),
    );
    dialog.style.setProperty("--nwsb-gallery-post-width", `${postWidth}px`);
    dialog.style.setProperty("--nwsb-gallery-stage-height", `${stageHeight}px`);
  }
  function showSlide(index) {
    if (!currentRecord) return;
    const posts = currentRecord.posts;
    const post = posts[activeIndex];
    const media = postMedia(post);
    activeSlide = Math.max(0, Math.min(index, media.length - 1));
    const item = media[activeSlide];
    const image = modal.querySelector(".nwsb-native-gallery__stage img");
    const video = modal.querySelector(".nwsb-native-gallery__stage video");
    video.pause();
    if (item.type === "video") {
      image.hidden = true;
      image.removeAttribute("src");
      video.hidden = false;
      video.defaultMuted = true;
      video.muted = true;
      video.poster = item.poster ? withVersion(item.poster) : "";
      video.src = withVersion(item.src);
      video.setAttribute(
        "aria-label",
        `Video ${activeSlide + 1} of ${media.length} in New Wave Swim Buoy Instagram highlight ${activeIndex + 1} of ${posts.length} for ${monthLabel(currentMonth)}`,
      );
      video.load();
    } else {
      video.hidden = true;
      video.removeAttribute("src");
      video.removeAttribute("poster");
      video.load();
      image.hidden = false;
      image.src = withVersion(item.src);
      image.alt = `Image ${activeSlide + 1} of ${media.length} in New Wave Swim Buoy Instagram highlight ${activeIndex + 1} of ${posts.length} for ${monthLabel(currentMonth)}`;
      image.decoding = "async";
      if (item.width) image.width = item.width;
      else image.removeAttribute("width");
      if (item.height) image.height = item.height;
      else image.removeAttribute("height");
    }
    const previous = modal.querySelector(".nwsb-native-gallery__media-nav--prev");
    const next = modal.querySelector(".nwsb-native-gallery__media-nav--next");
    const counter = modal.querySelector(".nwsb-native-gallery__media-counter");
    const multiple = media.length > 1;
    previous.hidden = !multiple;
    next.hidden = !multiple;
    counter.hidden = !multiple;
    previous.disabled = activeSlide === 0;
    next.disabled = activeSlide === media.length - 1;
    counter.textContent = `${activeSlide + 1} / ${media.length}`;
    sizeModalForItem(item);
  }
  function showPost(index) {
    if (!currentRecord) return;
    const posts = currentRecord.posts;
    activeIndex = (index + posts.length) % posts.length;
    const post = posts[activeIndex];
    activeSlide = 0;
    const author = post.author || "newnewwaveswimbuoy";
    const postUrl = post.url || "";
    [
      modal.querySelector(".nwsb-native-gallery__author"),
      modal.querySelector(".nwsb-native-gallery__caption-author"),
    ].forEach((link) => {
      link.textContent = author;
      link.title = "View original post on Instagram";
      link.setAttribute("aria-label", `Open ${author}'s original Instagram post`);
      if (postUrl) link.href = postUrl;
      else link.removeAttribute("href");
    });
    modal.querySelector(".nwsb-native-gallery__caption-text").textContent = post.caption || "";
    const socialProof = modal.querySelector(".nwsb-native-gallery__social-proof");
    const engagement = [];
    if (Number.isFinite(post.likes)) engagement.push(`${post.likes.toLocaleString()} likes`);
    if (Number.isFinite(post.comments)) engagement.push(`${post.comments.toLocaleString()} comments`);
    socialProof.textContent = engagement.join(" · ");
    socialProof.hidden = engagement.length === 0;
    socialProof.title = "Instagram engagement snapshot captured September 4, 2026";
    modal.querySelector(".nwsb-native-gallery__verified").hidden =
      author !== "newnewwaveswimbuoy";
    modal.querySelector(".nwsb-native-gallery__counter").textContent =
      `${monthLabel(currentMonth)} · post ${activeIndex + 1} of ${posts.length}`;
    showSlide(0);
  }
  function openModal(index) {
    if (!currentRecord) return;
    returnFocus = document.activeElement;
    modal.hidden = false;
    document.body.classList.add("nwsb-gallery-modal-open");
    showPost(index);
    modal.querySelector(".nwsb-native-gallery__close").focus();
  }
  function closeModal() {
    const video = modal.querySelector(".nwsb-native-gallery__stage video");
    video.pause();
    video.removeAttribute("src");
    video.load();
    modal.hidden = true;
    document.body.classList.remove("nwsb-gallery-modal-open");
    if (returnFocus?.focus) returnFocus.focus();
  }

  selects.forEach((select) =>
    select.addEventListener("change", () => renderMonth(select.value)),
  );
  gallery.querySelectorAll("[data-month-step]").forEach((button) =>
    button.addEventListener("click", () => {
      const nextIndex = months.indexOf(currentMonth) + Number(button.dataset.monthStep);
      if (months[nextIndex]) renderMonth(months[nextIndex]);
    }),
  );
  modal.querySelectorAll("[data-close]").forEach((element) =>
    element.addEventListener("click", closeModal),
  );
  modal.querySelectorAll("[data-post-step]").forEach((button) =>
    button.addEventListener("click", () =>
      showPost(activeIndex + Number(button.dataset.postStep)),
    ),
  );
  modal.querySelectorAll("[data-media-step]").forEach((button) =>
    button.addEventListener("click", () =>
      showSlide(activeSlide + Number(button.dataset.mediaStep)),
    ),
  );
  let resizeFrame = 0;
  const resizeModal = () => {
    if (modal.hidden || !currentRecord) return;
    cancelAnimationFrame(resizeFrame);
    resizeFrame = requestAnimationFrame(() => {
      const media = postMedia(currentRecord.posts[activeIndex]);
      sizeModalForItem(media[activeSlide]);
    });
  };
  window.addEventListener("resize", resizeModal, { passive: true });
  window.visualViewport?.addEventListener("resize", resizeModal, { passive: true });
  document.addEventListener("keydown", (event) => {
    if (modal.hidden || !currentRecord) return;
    if (event.key === "Escape") closeModal();
    if (event.key === "ArrowUp") showPost(activeIndex - 1);
    if (event.key === "ArrowDown") showPost(activeIndex + 1);
    if (event.key === "ArrowLeft") {
      if (activeSlide > 0) showSlide(activeSlide - 1);
      else showPost(activeIndex - 1);
    }
    if (event.key === "ArrowRight") {
      const media = postMedia(currentRecord.posts[activeIndex]);
      if (activeSlide < media.length - 1) showSlide(activeSlide + 1);
      else showPost(activeIndex + 1);
    }
  });

  showSkeleton();
  renderMonth(currentMonth, false);
})();
